import { useState } from "react";

export interface ActionNotice {
	kind: "success" | "error";
	text: string;
}

/**
 * Cycle d'une action qui envoie un email : demande de confirmation, envoi, puis
 * message de résultat.
 *
 * Le projet interdit `window.confirm` : la confirmation passe par un composant
 * dialogue, que cette logique alimente. `execute` renvoie le texte de succès ;
 * s'il lève une erreur, `describeError` en tire le texte affiché.
 */
export function useConfirmedEmailAction() {
	const [isConfirming, setIsConfirming] = useState(false);
	const [isSending, setIsSending] = useState(false);
	const [notice, setNotice] = useState<ActionNotice | null>(null);

	const ask = () => {
		setNotice(null);
		setIsConfirming(true);
	};

	const cancel = () => setIsConfirming(false);

	const confirm = async (
		execute: () => Promise<string>,
		describeError: (error: unknown) => string,
	) => {
		setIsSending(true);
		try {
			const text = await execute();
			setNotice({ kind: "success", text });
		} catch (error) {
			setNotice({ kind: "error", text: describeError(error) });
		} finally {
			setIsSending(false);
			setIsConfirming(false);
		}
	};

	return { isConfirming, isSending, notice, ask, cancel, confirm };
}
